import React from 'react';
import {graphql} from 'gatsby';
import get from 'lodash/get';

import Headline from 'ssg-themes/src/themes/hijunior/modules/Headline/Headline';
import Categories from 'ssg-themes/src/themes/hijunior/modules/Categories/Categories';
import Content from 'ssg-themes/src/themes/hijunior/modules/Content/Content';
import News from 'ssg-themes/src/themes/hijunior/modules/News/News';

import {DATA} from '../data/pl/index.data';
import readingTime from '../utils/getReadingTime';
import Seo from "../components/Seo/Seo";
import Base from "../templates/base-pl";

import * as styles from './index.module.scss';

const HomePage = props => {
  const postsModel = get(props, 'data.allContentfulBlogPost.edges');

  const posts = postsModel.map(({node}) => ({
    heading: node.seo?.title || node.shortHeading || node.heading,
    date: node.createdAt,
    readTime: node.content?.content && `${node.content.content && readingTime(node.content.content)} min`,
    href: `/${node.node_locale}/${node.category?.slug}/${node.slug}`,
    category: node.category?.shortHeading || node.category?.heading,
    comments: node.category?.slug,
    description: node.shortContent,
    picture: {
      xs: {
        src: node.thumbnailImage && node.thumbnailImage.url ? node.thumbnailImage.url : false,
        width: 350,
        height: 227
      },
      alt: node.heading
    },
  }));


  return <Base>
    <Seo
      lang="pl"
      hreflang={[
        {
          rel: 'alternate',
          href: 'https://hijunior.com',
          hreflang: 'x-default'
        },
        {
          rel: 'alternate',
          href: 'https://hijunior.com',
          hreflang: 'en-us'
        },
        {
          rel: 'alternate',
          href: 'https://hijunior.com/pl',
          hreflang: 'pl'
        }
      ]}
      title='Zadbaj o zdrowy rozwój Twojego dziecka – HiJunior'
      description='HiJunior to Twoje źródło niezbędnej wiedzy o rozwojowym wychowaniu. Znajdziesz tu rzetelne informacje o zdrowiu i rozwoju dzieci, oparte na najnowszych badaniach naukowych.'
    />
    <Headline classname={styles.headline} {...DATA.headline} />
    <Categories {...DATA.categories} />
    <Content {...DATA.content} />
    <News {...DATA.news} items={posts}/>

  </Base>;
};

export default HomePage;

export const pageQuery = graphql`
query GetPostsForHomepage {
  allContentfulBlogPost(
    limit: 9
    filter: {node_locale: {eq: "pl"}, slug: {ne: null}, options: {nin: "Hide in listing"}}
    sort: {createdAt: DESC}
  ) {
    edges {
      node {
        id
        slug
        node_locale
        shortContent
        options
        content {
          content
        }
        thumbnailImage {
          url
        }
        category {
          slug
          heading
          shortHeading
        }
        heading
        shortHeading
        createdAt(locale: "pl", formatString: "D MMMM")
        rawDate: createdAt
        seo {
          title
        }
      }
    }
  }
}
`;
